import {
  VIEW_SET_SPINNER,
  VIEW_SET_HOMEPAGE_KEY,
  VIEW_SET_MODEL,
  VIEW_SET_STORAGEPAGE_KEY,
  VIEW_SET_HOMEPAGE_EMPLOYEE_CUTTING,
} from '../types/view';

export const setSpinner = (isSpinner) => ({
  type: VIEW_SET_SPINNER,
  isSpinner,
});

export const setHomePageKey = (key) => ({
  type: VIEW_SET_HOMEPAGE_KEY,
  key,
});

export const setItemModelEdge = (key, value) => ({
  type: VIEW_SET_MODEL,
  key,
  value,
});

export const setStoragePageKey = (key) => ({
  type: VIEW_SET_STORAGEPAGE_KEY,
  key,
});

export const setHomePageEmployeeCutting = (key) => ({
  type: VIEW_SET_HOMEPAGE_EMPLOYEE_CUTTING,
  key,
});
